"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var o = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var o__default = /*#__PURE__*/_interopDefaultLegacy(o);

var l=o__default["default"].svg.attrs({x:"0px",y:"0px",viewBox:"0 0 86 107.4",style:{enableBackground:"new 0 0 86 107.4"},children:jsxRuntime.jsx("g",{children:jsxRuntime.jsxs("g",{children:[jsxRuntime.jsx("g",{children:jsxRuntime.jsx("path",{className:"st0",d:`M37.7,58.6l30.1,47.1c0.8,1.1,1.9,1.7,3.3,1.7h11.1c2.1,0,3.8-1.7,3.8-3.8V3.8c0-3.6-4.5-5.2-6.9-2.4
				L37.7,54C36.8,55.2,36.8,57.2,37.7,58.6z`})}),jsxRuntime.jsx("g",{children:jsxRuntime.jsx("path",{className:"st0",d:`M3.9,107.3h19.8c2.1,0,3.8-1.7,3.8-3.8V78.2c0-3.6-4.5-5.2-6.9-2.4L0.8,101.1
				C-1.1,103.8,0.8,107.3,3.9,107.3z`})})]})})})`
  .st0 {
    fill: #fff;
  }
`;var p=o.keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`,I=o.keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.2);
  }
`,R=o.keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`,W=r=>o.keyframes`
  0% {
    left: 18px;
    ${r}: 18px;
  }
  100% {
    left: 18px;
    ${r}: 42px;
  }
`,L=r=>o.keyframes`
  0% {
    background: transparent;
    border: 4px solid transparent;

    ${r==="top"?"border-bottom-color: var(--color-blurple-600);":"border-top-color: var(--color-blurple-600);"}
  }
  100% {
    background: transparent;
    border: 4px solid transparent;
    height: 50px;
    left: -5px;
    width: 50px;

    ${r}: -2px;

    ${r==="top"?"border-bottom-color: var(--color-blurple-600);":`border-top-color: var(--color-blurple-600);
          `}
  }
`,i=o__default["default"].div`
  display: grid;
  grid-template-columns: 1fr;
`,c=o__default["default"].div`
  animation: ${p} 0.6s ease-in-out 1, ${R} 1.5s linear 0.5s infinite;
  background: var(--gradient-blurple);
  border-radius: 50%;
  display: block;
  grid-column-start: 1;
  grid-row-start: 1;
  height: 40px;
  position: relative;
  transform: translateZ(0);
  width: 40px;
  will-change: transform;
`,s=o__default["default"].div`
  background: var(--color-blurple-600);
  border-radius: 50%;
  height: 6px;
  left: 18px;
  position: absolute;
  width: 6px;
  transform: translateZ(0);
  will-change: transform;

  ${({$position:r})=>o.css`
    animation: ${W(r)} 0.5s linear 1 0.5s forwards,
      ${L(r)} 0.5s linear 1 1s forwards,
      ${I} 0.5s linear 1 3s forwards;

    ${r}: 18px;
  `}
`,d=o__default["default"].div`
  align-items: center;
  animation: ${p} 0.6s ease-in-out 1;
  background: var(--gradient-blurple);
  border-radius: 100%;
  display: flex;
  grid-column-start: 1;
  grid-row-start: 1;
  height: 40px;
  justify-content: center;
  position: absolute;
  transform: translateZ(0);
  width: 40px;
  will-change: transform;
`,f=o__default["default"](l)`
  width: 20px;
  height: 20px;
`;var m=()=>{let[r,u]=react.useState(0),b=react.useRef(null),x=react.useRef(null),h=react.useRef(null);return react.useEffect(()=>{let v=setInterval(()=>u(w=>w>0?0:1),3600);return ()=>{clearInterval(v);}},[r]),jsxRuntime.jsxs(i,{role:"progressbar","aria-label":"Loading","aria-busy":!0,"aria-live":"polite",children:[jsxRuntime.jsxs(c,{ref:b,children:[jsxRuntime.jsx(s,{$position:"top",ref:x}),jsxRuntime.jsx(s,{$position:"bottom",ref:h})]}),jsxRuntime.jsx(d,{children:jsxRuntime.jsx(f,{})})]},r)};m.displayName="Spinner";var V=m;

exports.a = V;
